<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style="min-height:85vh" class="admin_secondary">
            <v-card-title class="secondary white--text">
              Memberships
              <v-spacer></v-spacer>
              <v-btn
                fab
                small
                color="success"
                class="mr-4"
                dark
                @click="save"
                v-if="modified && !loading"
              >
                <v-icon>fa-save</v-icon>
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>
            <v-container class="white--text">
              <v-row align="center">
                <v-col cols="12">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="3"
                        v-for="(plan,p,i) in website.memberships"
                        :key="i"
                      >
                        <v-card>
                          <v-card-title class="white--text" :style="plan.style">{{plan.label}}</v-card-title>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  label="Name"
                                  readonly
                                  disabled
                                  hide-details
                                  v-model="plan.name"
                                  @change="onChange"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  label="Label"
                                  hide-details
                                  v-model="plan.label"
                                  @change="onChange"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  label="Style"
                                  hide-details
                                  v-model="plan.style"
                                  @change="onChange"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  label="Portal Limit"
                                  hide-details
                                  @change="onChange"
                                  type="number"
                                  v-model="plan.limit"
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12" v-if="plan.period">
                                <v-text-field
                                  label="Trial period (days)"
                                  hide-details
                                  @change="onChange"
                                  type="number"
                                  v-model="plan.period"
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12" v-if="plan.cycle">
                                <v-container fluid class="pa-0">
                                  <v-row>
                                    <v-col cols="12">
                                      <v-text-field
                                        label="Yearly price"
                                        hide-details
                                        @change="onChange"
                                        type="number"
                                        v-model="plan.cycle.year.price"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        label="Yearly price stripe id"
                                        hide-details
                                        @change="onChange"
                                        v-model="plan.cycle.year.stripe_id"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        label="Monthly price"
                                        hide-details
                                        @change="onChange"
                                        type="number"
                                        v-model="plan.cycle.month.price"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        label="Monthly price stripe id"
                                        hide-details
                                        @change="onChange"
                                        v-model="plan.cycle.month.stripe_id"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "AdminPortals",
  components: {},
  data() {
    return {
      editorOps: {},
      website: {},
      loading: false,
      modified: false
    };
  },
  async beforeRouteLeave(to, from, next) {
    if (
      this.modified &&
      !confirm("Do you really want to leave? you have unsaved changes!")
    ) {
      return;
    } else {
      next();
    }
  },
  methods: {
    onChangeEditor(delta, oldDelta) {
     if (oldDelta.ops[0].insert !== "\n") {
        if (oldDelta.ops.length !== delta.ops.length) {
          this.onChange();
        }
      }
    },
    onChange() {
      this.modified = true;
    },
    async load() {
      this.loading = true;
      try {
        this.website = await this.$api("/admin/website");
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;
      try {
        this.website = await this.$api.patch("/admin/website", this.website);
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  },
  created() {
    this.load();
  }
};
</script>

<style>
</style>